import { Callout } from "../components/Callout.js";

export const meta = {
  title: "Sign Extension とは",
  updatedAt: "2026-07-13",
};

export function Content() {
  return (
    <>
      <p>
        <strong>Sign Extension for クラウドサイン</strong> は、HubSpot CRM の取引・会社・
        コンタクトの画面から、クラウドサインの電子契約書をスムーズに送信し、
        締結ステータスを自動で同期する連携アプリです。
      </p>

      <h2>主な機能</h2>
      <ul>
        <li>HubSpot レコード（取引・会社・コンタクト）から書類を直接送信</li>
        <li>取引のプロパティから宛先・契約相手会社名を自動取得</li>
        <li>クラウドサインのテンプレートを呼び出してファイル不要で送信も可能</li>
        <li>社内承認者を「固定送付宛先」に登録して回覧順を自動化</li>
        <li>送信状況・締結ステータスを 15 分間隔で自動同期</li>
        <li>締結 PDF・合意締結証明書を HubSpot にも自動アップロード</li>
        <li>複数の送信者（クラウドサイン Client ID）を切り替えて利用可能</li>
      </ul>

      <h2>必要な環境</h2>
      <ul>
        <li>HubSpot アカウント（Free を含むすべてのプランで利用可能）</li>
        <li>クラウドサインの法人契約（API 利用可能なプラン）</li>
        <li>当サービスのアカウント（メールアドレスで登録）</li>
      </ul>

      <Callout type="tip" title="まずは使ってみる">
        <a href="/guide/quick-start">クイックスタート</a> で、登録から初回送信までの
        手順を一気に確認できます。
      </Callout>
    </>
  );
}
